import cartClient from '%evp_ticket_frontend/js/redux/currentCart/service/CartClient';
import setWaitingHallUpdate
    from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actions/setWaitingHallUpdate';
import { openSnackbar, VARIANT_ERROR } from '%app/js/common/components/material/Snackbar';
import Translator from '%app/js/common/services/translator';
import setCart from './setCart';

function fetchCart({ token }) {
    return async (dispatch) => {
        dispatch(setWaitingHallUpdate(true));

        let cart = null;
        try {
            cart = await cartClient.getCart({ token });
        } catch (error) {
            if (error.response && error.response.status < 500) {
                dispatch(openSnackbar({
                    variant: VARIANT_ERROR,
                    message: Translator.trans(error.response.data.error_description),
                }));
            } else {
                throw error;
            }
        } finally {
            if (cart !== null) {
                dispatch(setCart(cart));
            }
            dispatch(setWaitingHallUpdate(false));
        }
    };
}

export default fetchCart;
